module.exports = "/assets/landing-cf/instagram/insta-feed-1.jpg?yE464Qu";